import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output, Input, Component, Pipe, Optional, NgModule } from '@angular/core';
import * as i3 from '@yourcause/common/i18n';
import { I18nModule } from '@yourcause/common/i18n';
import * as i4$1 from '@yourcause/common/links';
import { LinksModule } from '@yourcause/common/links';
import * as i1 from '@yourcause/common/notifier';
import * as i1$1 from '@angular/common/http';
import * as ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { isEmpty, isEqual } from 'lodash';
import { unparse, parse } from 'papaparse';
import { mergeMap, Observable, lastValueFrom, Subscription } from 'rxjs';
import * as i3$1 from '@yourcause/common/logging';
import * as i4 from '@yourcause/common/utils';
import { YCTwoWayEmitter, UtilsModule } from '@yourcause/common/utils';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@yourcause/common/buttons';
import { ButtonModule } from '@yourcause/common/buttons';
import * as i7 from '@yourcause/common/icons';
import { IconsModule } from '@yourcause/common/icons';
import * as i8 from '@angular/forms';
import * as i2 from '@yourcause/common/core-forms';
import { FormControlComponent, CoreFormsModule } from '@yourcause/common/core-forms';

class YcFile {
    constructor(fileName, file, fileUrl, fileUploadId) {
        this.fileName = fileName;
        this.file = file;
        this.fileUrl = fileUrl;
        this.fileUploadId = fileUploadId;
    }
}
var TableDataDownloadFormat;
(function (TableDataDownloadFormat) {
    TableDataDownloadFormat[TableDataDownloadFormat["CSV"] = 1] = "CSV";
    TableDataDownloadFormat[TableDataDownloadFormat["XLSX"] = 2] = "XLSX";
})(TableDataDownloadFormat || (TableDataDownloadFormat = {}));

class FileTypeService {
    constructor(notifier, i18n, logger, arrayHelper) {
        this.notifier = notifier;
        this.i18n = i18n;
        this.logger = logger;
        this.arrayHelper = arrayHelper;
        this.permittedMagicNumbers = {
            rtf: [
                '7B5C7274'
            ],
            odt: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            webm: [
                '1A45DFA3'
            ],
            wav: [
                '52494646'
            ],
            aac: [
                'FFF1',
                'FFF9'
            ],
            midi: [
                '4D546864'
            ],
            mid: [
                '4D546864'
            ],
            mp3: [
                'FFFB',
                'FFF3',
                'FFF2',
                '494433'
            ],
            cda: [
                '52494646'
            ],
            oga: [
                '4F676753'
            ],
            mp4: [
                '66747970'
            ],
            mpeg: [
                '000001B3'
            ],
            mkv: [
                '1A45DFA3'
            ],
            avi: [
                '52494646'
            ],
            ogv: [
                '4F676753'
            ],
            webp: [
                '52494646'
            ],
            tif: [
                '49492A00',
                '4D4D002A'
            ],
            tiff: [
                '49492A00',
                '4D4D002A'
            ],
            bmp: [
                '424D'
            ],
            gif: [
                '47494638'
            ],
            jpg: [
                'FFD8FFDB',
                'FFD8FFE0',
                'FFD8FFEE',
                'FFD8FFE1',
                'FFD8FFE2',
                'FFD8FFE8'
            ],
            jpeg: [
                'FFD8FFDB',
                'FFD8FFE0',
                'FFD8FFEE',
                'FFD8FFE1',
                'FFD8FFE2',
                'FFD8FFE8'
            ],
            png: [
                '89504E47'
            ],
            bz2: [
                '425A68'
            ],
            rar: [
                '52617221'
            ],
            tar: [
                '75737461'
            ],
            zip: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            '7z': [
                '377ABCAF'
            ],
            gz: [
                '1F8B'
            ],
            xls: [
                'D0CF11E0'
            ],
            xlsx: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            ods: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            doc: [
                'D0CF11E0',
                '0D444F43'
            ],
            docx: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            odp: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            ppt: [
                'D0CF11E0'
            ],
            pptx: [
                '504B0304',
                '504B0506',
                '504B0708'
            ],
            pdf: [
                '25504446'
            ]
        };
    }
    getPermittedExtensionsObject() {
        return {
            [this.i18n.translate('common:textText', {}, 'Text')]: [
                'txt',
                'rtf',
                'odt'
            ],
            [this.i18n.translate('common:textAudio', {}, 'Audio')]: [
                'webm',
                'wav',
                'aac',
                'midi',
                'mid',
                'mp3',
                'cda',
                'oga',
                'opus'
            ],
            [this.i18n.translate('common:textVideo', {}, 'Video')]: [
                'mp4',
                'mpeg',
                'mkv',
                'avi',
                'ogv'
            ],
            [this.i18n.translate('common:textImage', {}, 'Image')]: [
                'webp',
                'tif',
                'tiff',
                'bmp',
                'gif',
                'jpg',
                'jpeg',
                'png'
            ],
            [this.i18n.translate('GLOBAL:textArchive', {}, 'Archive')]: [
                'bz',
                'bz2',
                'rar',
                'tar',
                'zip',
                '7z',
                'gz'
            ],
            [this.i18n.translate('common:textSpreadsheet', {}, 'Spreadsheet')]: [
                'xls',
                'xlsx',
                'csv',
                'ods'
            ],
            [this.i18n.translate('common:textWord', {}, 'Word')]: [
                'doc',
                'docx'
            ],
            [this.i18n.translate('common:textPowerpoint', {}, 'Powerpoint')]: [
                'odp',
                'ppt',
                'pptx'
            ],
            [this.i18n.translate('common:textPdf', {}, 'PDF')]: [
                'pdf'
            ]
        };
    }
    getAcceptedFileTypeOptions() {
        const permittedExtensions = this.getPermittedExtensionsObject();
        return this.arrayHelper.sort(Object.keys(permittedExtensions).map((groupName) => {
            return {
                label: groupName,
                value: groupName,
                isExpanded: true,
                dependentOptions: permittedExtensions[groupName].map((extension) => {
                    return {
                        label: extension,
                        value: extension
                    };
                })
            };
        }), 'label');
    }
    getAllPermittedExtensions(acceptedFileTypes) {
        if (acceptedFileTypes?.length > 0) {
            return acceptedFileTypes;
        }
        else {
            const permittedExtensions = this.getPermittedExtensionsObject();
            return Object.keys(permittedExtensions).reduce((acc, grouping) => {
                return [
                    ...acc,
                    ...permittedExtensions[grouping].map((ext) => ext)
                ];
            }, []);
        }
    }
    getImageFileTypes() {
        const permittedExtensions = this.getPermittedExtensionsObject();
        return permittedExtensions[this.i18n.translate('common:textImage', {}, 'Image')];
    }
    isPermittedFileExtension(extension, acceptedFileTypes) {
        return this.getAllPermittedExtensions(acceptedFileTypes).some((value) => extension === value);
    }
    isExcludedFromMagicNumberCheck(extension) {
        const permitted = this.getAllPermittedExtensions().filter((ext) => {
            return !Object.keys(this.permittedMagicNumbers).includes(ext);
        });
        return permitted.includes(extension);
    }
    isPermittedMagicNumber(extension, magicNumber) {
        return this.permittedMagicNumbers[extension].some(value => magicNumber.startsWith(value));
    }
    async getFileMagicNumber(file, fileExtension) {
        let start = 0;
        let end = 4;
        switch (fileExtension) {
            case 'mp4':
                start = 4;
                end = 8;
                break;
            case 'tar':
                start = 257;
                end = 261;
        }
        return await file
            .slice(start, end)
            .arrayBuffer()
            .then((buffer) => Array.from(new Uint8Array(buffer))
            .map((byte) => byte.toString(16).padStart(2, '0'))
            .join('')
            .toUpperCase());
    }
    /**
     * Get Invalid File Error Message
     *
     * @param errorMessage: Error Message
     * @returns the translated error message to display to user
     */
    getInvalidFileErrorMessage(errorMessage) {
        let message = '';
        let isGenericError = false;
        if (errorMessage === 'File size is invalid.') {
            message = this.i18n.translate('common:genericFileSizeError', {}, errorMessage);
        }
        else if (errorMessage === 'File type is invalid.') {
            message = this.i18n.translate('common:genericFileTypeError', {}, errorMessage);
        }
        else if (errorMessage?.includes('Request body too large')) {
            message = this.i18n.translate('common:fileUploadIsTooLarge', {}, 'The selected file(s) are too large.');
        }
        else {
            message = this.i18n.translate('common:genericFileUploadError', {}, 'There was an error uploading the file(s).');
            isGenericError = true;
        }
        return {
            message,
            isGenericError
        };
    }
    /**
     * Display the Invalid File Error Message
     *
     * @param errorMessage: Error Message
     * @param err: HTTP Error
     */
    displayInvalidFileUploadErrorMessage(errorMessage, err) {
        const { message, isGenericError } = this.getInvalidFileErrorMessage(errorMessage);
        this.notifier.error(message);
        if (isGenericError) {
            this.logger.error(err);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileTypeService, deps: [{ token: i1.NotifierService }, { token: i3.I18nService }, { token: i3$1.LogService }, { token: i4.ArrayHelpersService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileTypeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileTypeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.NotifierService }, { type: i3.I18nService }, { type: i3$1.LogService }, { type: i4.ArrayHelpersService }] });

const b64Regex = /data\:(.*)\;base64\,/i;
const maskedFileName = '******';
class FileService {
    constructor(http, fileTypeService) {
        this.http = http;
        this.fileTypeService = fileTypeService;
    }
    stripBase64Header(input) {
        return input.replace(b64Regex, '');
    }
    convertFileToUrl(input) {
        return URL.createObjectURL(input);
    }
    convertToBlob(input) {
        return new Promise(resolve => setTimeout(() => {
            const rawString = this.stripBase64Header(input);
            const match = input.match(b64Regex)[1];
            const byteCharacters = atob(rawString);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            resolve(new Blob([byteArray], {
                type: match
            }));
        }));
    }
    convertBlobToFile(blob, fileName) {
        return Object.assign(blob, {
            lastModifiedDate: Date.now(),
            name: fileName
        });
    }
    convertFileToBlob(file) {
        return this.convertFileToB64(file).pipe(mergeMap((b64String) => {
            if (b64String) {
                return this.convertToBlob(b64String);
            }
            else {
                return null;
            }
        }));
    }
    convertFileToB64(file) {
        return new Observable(sub => {
            const fileReader = new FileReader();
            fileReader.onloadend = function (loadEvent) {
                sub.next(loadEvent.target.result);
                sub.complete();
            };
            if (file) {
                fileReader.readAsDataURL(file);
            }
            else {
                sub.next('');
            }
        });
    }
    //GET requests to url to get a file stream (blob)
    getBlob(url) {
        return lastValueFrom(this.http.get(url, {
            responseType: 'blob'
        }));
    }
    //POST requests to url to get a file stream (blob)
    postBlob(url, data) {
        return lastValueFrom(this.http.post(url, data, {
            observe: 'body',
            responseType: 'blob'
        }));
    }
    readAsString(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('loadend', () => resolve(reader.result));
            reader.addEventListener('error', (e) => reject(e));
            reader.readAsText(file);
        });
    }
    convertObjectArrayToCSVString(input) {
        /// remove invalid characters (@, =, {, }, <) from first character
        const cleanInput = input.map(obj => {
            return Object.keys(obj)
                .reduce((acc, key) => {
                //make sure not null
                if (obj[key] !== null &&
                    obj[key] !== undefined) {
                    return {
                        ...acc,
                        [key]: obj[key].toString().replace(/^[\^@={}<]/, '')
                    };
                }
                else {
                    return {
                        ...acc,
                        [key]: ''
                    };
                }
            }, {});
        });
        /// to hide/show certain columns, pass in the filtered keys as second arg
        return unparse(cleanInput, {
            header: true,
            quotes: true
        });
    }
    downloadCSV(csv) {
        csv = this.prependUtfBomToCsv(csv);
        const csvFile = new Blob([csv], { type: 'text/csv' });
        this.saveAs(csvFile, 'export.csv');
    }
    downloadString(input, type, filename) {
        if (type === 'text/csv') {
            input = this.prependUtfBomToCsv(input);
        }
        const encodedUri = this.encodeInput(type, input);
        this.downloadUrlFile(encodedUri, filename);
    }
    prependUtfBomToCsv(csv) {
        return '\ufeff' + csv;
    }
    encodeInput(type, input) {
        return `data:${type};charset=utf-8,${encodeURIComponent(input)}`;
    }
    testCanDownload(raw, type = 'application/octet-stream') {
        return this.encodeInput(type, raw).length < (64 * 1024);
    }
    downloadUrlFile(url, filename = url.split('/').pop()) {
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', filename);
        a.setAttribute('target', '_blank');
        a.style.visibility = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    downloadRaw(raw, filename = 'export.bin') {
        return this.downloadString(raw, 'application/octet-stream', filename);
    }
    /**
     * Downloads the given CSV string as an Excel file
     *
     * @param csv: CSV string to download
     */
    async downloadExcel(csv) {
        const adaptForHeaders = parse(csv, {
            header: false
        });
        const headersArray = adaptForHeaders.data[0];
        const columns = headersArray.map((headerName) => {
            return {
                header: headerName,
                key: headerName
            };
        });
        const adapted = parse(csv, {
            header: true
        });
        const buffer = await this.createExcelFile(columns, adapted.data);
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });
        this.saveAs(blob, 'export');
    }
    async createExcelFile(columns, rows) {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('sheet');
        sheet.columns = columns;
        sheet.addRows(rows);
        return workbook.xlsx.writeBuffer();
    }
    downloadByFormat(csv, format) {
        switch (format) {
            case TableDataDownloadFormat.XLSX:
                return this.downloadExcel(csv);
            default:
            case TableDataDownloadFormat.CSV:
                return this.downloadCSV(csv);
        }
    }
    saveAs(blob, fileName) {
        return FileSaver.saveAs(blob, fileName);
    }
    getBlobFromCanvas(canvas, type = 'image/png', quality) {
        return new Promise((res) => {
            canvas.toBlob((blob) => {
                res(blob);
            }, type, quality);
        });
    }
    async downloadUrlAs(url, fileName = url.split('/').pop()) {
        const blob = await this.getBlob(url);
        return this.saveAs(blob, fileName);
    }
    async downloadPostUrlAs(url, fileName = url.split('/').pop(), data) {
        const blob = await this.postBlob(url, data);
        return this.saveAs(blob, fileName);
    }
    validateFileMatchesTemplate(headers, rows, requiredHeaders = headers, uniqueByHeader) {
        const parsedRows = this.removeEmptyRows(headers, rows);
        const errors = [];
        if (rows && parsedRows && parsedRows.length) {
            const missingFieldMap = {};
            parsedRows.forEach((row, index) => {
                headers.forEach((header) => {
                    const isRequiredHeader = requiredHeaders.includes(header);
                    if (!(header in row) || (isRequiredHeader && isEmpty(row[header]))) {
                        missingFieldMap[header] = missingFieldMap[header] || [];
                        missingFieldMap[header].push(index);
                    }
                });
            });
            Object.keys(missingFieldMap)
                .map(key => key)
                .map(key => {
                const existingIndices = missingFieldMap[key];
                existingIndices.forEach(index => {
                    errors.push({
                        row: index + 1,
                        message: {
                            i18nKey: 'common:textFileIsMissingRequiredFieldsDynamic',
                            context: {
                                missingField: key
                            },
                            defaultValue: 'This row is missing this required field: __missingField__'
                        }
                    });
                });
            });
            if (uniqueByHeader) {
                parsedRows.forEach((row, index) => {
                    const foundIndex = parsedRows.findIndex(foundRow => foundRow[uniqueByHeader] === row[uniqueByHeader]);
                    const isDupe = foundIndex !== index;
                    if (isDupe) {
                        errors.push({
                            message: {
                                i18nKey: 'common:textFileContainsDuplicates',
                                context: {},
                                defaultValue: 'This file contains duplicate records'
                            },
                            row: index + 2
                        });
                    }
                });
            }
        }
        else {
            errors.push({
                row: -1,
                message: {
                    i18nKey: 'common:textFileMustNotBeEmpty',
                    context: {},
                    defaultValue: 'File must not be empty'
                }
            });
        }
        return errors;
    }
    removeEmptyRows(headers, rows) {
        return rows.filter((row) => !headers.every((header) => isEmpty(row[header])));
    }
    initiateUserUpload() {
        return new Promise((res, rej) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.hidden = true;
            input.addEventListener('change', (event) => {
                const [file] = event.target.files;
                res(file);
            });
            input.addEventListener('cancel', () => {
                res(null);
            });
            document.body.appendChild(input);
            input.click();
        });
    }
    /**
     *
     * @param fileUrl url containing fileId and fileName
     */
    breakdownUrl(fileUrl) {
        const applicableInfo = fileUrl.split('?')[1];
        return applicableInfo.split('&')
            .map(keyValueString => keyValueString.split('='))
            .reduce((acc, keyValue) => ({
            ...acc,
            [keyValue[0]]: keyValue[1]
        }), {
            fileId: '',
            fileName: ''
        });
    }
    /**
     * Validates if the file upload is valid. If not, returns error.
     *
     * @param file File to process
     * @param maxFileSize Max File Size
     * @param filesCombinedSizeToCheck If we need to validate more than one file's size,
     * this parameter validates their total size is less than the max file size (optional)
     * @param acceptedFileTypes: File types that should be accepted (if not passed, it will default to our full list of accepted file types)
     * @returns if the file is valid, and if not an error message
     */
    async validateFileUpload(file, maxFileSize, filesCombinedSizeToCheck, acceptedFileTypes) {
        const sizeValidationInfo = this.validateFileSize(file, maxFileSize, filesCombinedSizeToCheck);
        if (!sizeValidationInfo.validFile) {
            return sizeValidationInfo;
        }
        return this.validateFileType(file, acceptedFileTypes);
    }
    getFilesCombinedSize(newFileSize, currentAttachments) {
        const attachmentsTotalSize = currentAttachments
            .reduce((acc, attachment) => {
            let attachmentFileSize;
            if ('fileSize' in attachment) {
                attachmentFileSize = attachment.fileSize;
            }
            else if ('file' in attachment) {
                attachmentFileSize = attachment.file.size;
            }
            else {
                attachmentFileSize = 0;
            }
            return acc + attachmentFileSize;
        }, 0);
        return newFileSize + attachmentsTotalSize;
    }
    maxFileSizeToUserFriendly(maxSize) {
        let currentIncrement = 'B';
        let increments = [
            'KB',
            'MB',
            'GB'
        ];
        while (true) {
            if (maxSize > 1000 && increments.length) {
                maxSize = Math.floor(maxSize / 1000);
                currentIncrement = increments[0];
                increments = increments.slice(1);
            }
            else {
                return maxSize + currentIncrement;
            }
        }
    }
    validateFileSize(file, maxFileSize, filesCombinedSizeToCheck) {
        // verify the file has a size and that the size is greater than zero
        if (!file.size) {
            return {
                validFile: false,
                i18nKey: 'common:notificationFileSizeCantBeZero',
                i18nContext: {},
                defaultText: 'Please upload a file with size greater than 0',
            };
        }
        if (!!filesCombinedSizeToCheck && filesCombinedSizeToCheck > maxFileSize) {
            const maxFileSizeDisplay = this.maxFileSizeToUserFriendly(maxFileSize);
            return {
                validFile: false,
                i18nKey: 'common:notificationCombinedFileSizeExceedsMaximum',
                i18nContext: {
                    maxFileSizeDisplay
                },
                defaultText: 'The combined size of all files cannot exceed a total of __maxFileSizeDisplay__.',
            };
        }
        if (file.size > maxFileSize) {
            return {
                validFile: false,
                i18nKey: 'common:notificationFileTooLarge2',
                i18nContext: {
                    fileName: file.name,
                    fileSize: this.maxFileSizeToUserFriendly(maxFileSize)
                },
                defaultText: '__fileName__ is too large. The maximum file size is __fileSize__.',
            };
        }
        return {
            validFile: true
        };
    }
    async validateFileType(file, acceptedFileTypes) {
        const fileExtension = this.getFileExtension(file.name).toLowerCase();
        const isValidFileExtension = this.fileTypeService.isPermittedFileExtension(fileExtension, acceptedFileTypes);
        // verify the file's extenion is permitted
        if (!isValidFileExtension) {
            return {
                validFile: false,
                defaultText: '__fileName__ has an invalid extension. Please upload a different file.',
                i18nKey: 'common:notificationFileHasInvalidExtension',
                i18nContext: {
                    fileName: file.name
                }
            };
        }
        // determine if the file extension is excluded from magic number check
        const excludedFromMagicNumberCheck = this.fileTypeService.isExcludedFromMagicNumberCheck(fileExtension);
        if (!excludedFromMagicNumberCheck) {
            // get magic number and verify the file's magic number is permitted
            const fileMagicNumber = await this.fileTypeService.getFileMagicNumber(file, fileExtension);
            const isPermittedMagicNumber = this.fileTypeService.isPermittedMagicNumber(fileExtension, fileMagicNumber);
            if (!fileMagicNumber || !isPermittedMagicNumber) {
                return {
                    validFile: false,
                    defaultText: 'File extension of __fileName__ does not match its content. Please select another file to upload.',
                    i18nKey: 'common:notificationFileExtensionAndContentDoNotMatch',
                    i18nContext: {
                        fileName: file.name
                    }
                };
            }
        }
        return {
            validFile: true
        };
    }
    getFileExtension(fileName) {
        return fileName.split('.').pop();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileService, deps: [{ token: i1$1.HttpClient }, { token: FileTypeService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FileService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: FileTypeService }] });

class AddAttachmentButtonComponent {
    constructor(fileService, notifier, i18n, linkService) {
        this.fileService = fileService;
        this.notifier = notifier;
        this.i18n = i18n;
        this.linkService = linkService;
        this.onAddAttachment = new EventEmitter();
        this.onRemoveAttachment = new EventEmitter();
        this.downloadFile = new EventEmitter();
        this.acceptedFileTypesLink = this.linkService.getAcceptedFileTypesLink();
        this.hasError = false;
    }
    ngOnInit() {
        this.maxFileSizeForDisplay = this.fileService.maxFileSizeToUserFriendly(this.maxAttachmentsTotalSize);
    }
    viewAcceptedFileTypes() {
        window.open(this.acceptedFileTypesLink, '_blank');
    }
    handleRemoveAttachment(index) {
        this.onRemoveAttachment.emit(index);
    }
    async handleAddAttachment(files) {
        const attachment = await this.fileSelected(files);
        if (attachment) {
            this.onAddAttachment.emit({ attachment });
            this.attachments = [
                ...this.attachments,
                attachment
            ];
        }
    }
    handleAddAttachmentClick() {
        const input = document.createElement('input');
        input.type = 'file';
        input.hidden = true;
        input.addEventListener('change', (event) => {
            this.handleAddAttachment(event.target.files);
        });
        document.body.appendChild(input);
        input.click();
    }
    async fileSelected(files) {
        const filesCombinedSize = this.fileService.getFilesCombinedSize(files[0].size, this.attachments);
        const fileValidationInfo = await this.fileService.validateFileUpload(files[0], this.maxAttachmentsTotalSize, filesCombinedSize);
        if (fileValidationInfo.validFile) {
            this.hasError = false;
            return {
                fileName: files[0].name,
                file: files[0]
            };
        }
        else {
            this.hasError = true;
            this.notifier.error(this.i18n.translate(fileValidationInfo.i18nKey, fileValidationInfo.i18nContext, fileValidationInfo.defaultText));
            return null;
        }
    }
    clickDownload(outputEmit) {
        this.downloadFile.emit(outputEmit);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AddAttachmentButtonComponent, deps: [{ token: FileService }, { token: i1.NotifierService }, { token: i3.I18nService }, { token: i4$1.LinkService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: AddAttachmentButtonComponent, isStandalone: false, selector: "yc-add-attachment-button", inputs: { attachments: "attachments", maxAttachments: "maxAttachments", maxAttachmentsTotalSize: "maxAttachmentsTotalSize" }, outputs: { onAddAttachment: "onAddAttachment", onRemoveAttachment: "onRemoveAttachment", downloadFile: "downloadFile" }, ngImport: i0, template: "<div *ngFor=\"let attachment of attachments let index = index;\"\n  class=\"d-flex justify-content-between align-items-center\">\n  <!-- Left Side -->\n  <div class=\"d-flex align-items-center\">\n    <yc-fa\n      icon=\"paperclip\"\n      [light]=\"true\"\n      class=\"me-2\">\n    </yc-fa>\n    <div *ngIf=\"attachment.fileName\"\n      class=\"me-2\">\n      <yc-button *ngIf=\"attachment['accessURL']\"\n        [link]=\"true\"\n        (onClick)=\"clickDownload({\n          url: attachment['accessURL'],\n          fileName: attachment.fileName\n        })\"\n        class=\"anchor-tag\"\n        target=\"_blank\">\n        {{ attachment.fileName }}\n      </yc-button>\n      <ng-container *ngIf=\"!attachment['accessURL']\">\n        {{ attachment.fileName }}\n      </ng-container>\n    </div>\n  </div>\n  <!-- Right Side -->\n  <div>\n    <yc-button\n      [icon]=\"true\"\n      [value]=\"'common:textRemove' | ycI18n: 'Remove'\"\n      (onClick)=\"handleRemoveAttachment(index);\">\n      <yc-fa icon=\"times\" \n        [light]=\"true\" \n        class=\"text-danger\">\n      </yc-fa>\n    </yc-button>\n  </div>\n</div>\n\n<div class=\"d-flex mt-2\">\n  <yc-button *ngIf=\"!maxAttachments || attachments?.length < maxAttachments\"\n    class=\"pointer\"\n    [link]=\"true\"\n    [value]=\"'common:textAddAttachment' | ycI18n: 'Add attachment'\"\n    (onClick)=\"handleAddAttachmentClick()\">\n    <yc-fa \n      [light]=\"true\"\n      icon=\"plus\">\n    </yc-fa>\n    <yc-i18n\n      key=\"common:textAddAttachment\"\n      defaultValue=\"Add attachment\">\n    </yc-i18n>\n  </yc-button>\n  </div>\n  <yc-button *ngIf=\"hasError && acceptedFileTypesLink\"\n    class=\"mt-1\"\n    [link]=\"true\"\n    [langKey]=\"'common:textViewAcceptedFileTypes'\"\n    [defaultText]=\"'View accepted file types'\"\n    (onClick)=\"viewAcceptedFileTypes()\">\n  </yc-button>\n  <div>\n  <small>\n    <yc-i18n\n      key=\"common:maximumFileSizeText\"\n      [context]=\"{\n        maxFileSize: maxFileSizeForDisplay\n      }\"\n      defaultValue=\"Maximum file size: __maxFileSize__\">\n    </yc-i18n>\n  </small>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.ButtonComponent, selector: "yc-button", inputs: ["tabIndex", "disabled", "size", "fontSize", "buttonType", "primary", "link", "linkPath", "icon", "secondary", "textDanger", "textWarning", "textPrimary", "textSuccess", "borderOnHover", "noClick", "badgeValue", "value", "ariaDescribedBy", "minWidth", "alignTop", "tooltipText", "popoverTemplate", "container", "popoverContext", "popoverIsOpen", "popoverOutsideClickToClose", "placement", "adaptivePosition", "langKey", "defaultText", "translatedText", "fontAwesomeIcon", "isDropdownButton", "isFooterButton", "dropdownDirection", "dropdownActions", "isDropdownToggle", "isSplitDropdownToggle", "preventClickTracking", "leftAlignLinkText", "analyticsEventName", "customColor", "buttonElementId", "includeExpandedAria", "ariaExpanded"], outputs: ["onClick", "popoverIsOpenChange", "onPopoverReady", "onPopoverClick"] }, { kind: "component", type: i7.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }, { kind: "component", type: i3.I18nComponent, selector: "yc-i18n", inputs: ["key", "defaultValue", "context", "transform"] }, { kind: "pipe", type: i3.I18nPipe, name: "ycI18n" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AddAttachmentButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-add-attachment-button', standalone: false, template: "<div *ngFor=\"let attachment of attachments let index = index;\"\n  class=\"d-flex justify-content-between align-items-center\">\n  <!-- Left Side -->\n  <div class=\"d-flex align-items-center\">\n    <yc-fa\n      icon=\"paperclip\"\n      [light]=\"true\"\n      class=\"me-2\">\n    </yc-fa>\n    <div *ngIf=\"attachment.fileName\"\n      class=\"me-2\">\n      <yc-button *ngIf=\"attachment['accessURL']\"\n        [link]=\"true\"\n        (onClick)=\"clickDownload({\n          url: attachment['accessURL'],\n          fileName: attachment.fileName\n        })\"\n        class=\"anchor-tag\"\n        target=\"_blank\">\n        {{ attachment.fileName }}\n      </yc-button>\n      <ng-container *ngIf=\"!attachment['accessURL']\">\n        {{ attachment.fileName }}\n      </ng-container>\n    </div>\n  </div>\n  <!-- Right Side -->\n  <div>\n    <yc-button\n      [icon]=\"true\"\n      [value]=\"'common:textRemove' | ycI18n: 'Remove'\"\n      (onClick)=\"handleRemoveAttachment(index);\">\n      <yc-fa icon=\"times\" \n        [light]=\"true\" \n        class=\"text-danger\">\n      </yc-fa>\n    </yc-button>\n  </div>\n</div>\n\n<div class=\"d-flex mt-2\">\n  <yc-button *ngIf=\"!maxAttachments || attachments?.length < maxAttachments\"\n    class=\"pointer\"\n    [link]=\"true\"\n    [value]=\"'common:textAddAttachment' | ycI18n: 'Add attachment'\"\n    (onClick)=\"handleAddAttachmentClick()\">\n    <yc-fa \n      [light]=\"true\"\n      icon=\"plus\">\n    </yc-fa>\n    <yc-i18n\n      key=\"common:textAddAttachment\"\n      defaultValue=\"Add attachment\">\n    </yc-i18n>\n  </yc-button>\n  </div>\n  <yc-button *ngIf=\"hasError && acceptedFileTypesLink\"\n    class=\"mt-1\"\n    [link]=\"true\"\n    [langKey]=\"'common:textViewAcceptedFileTypes'\"\n    [defaultText]=\"'View accepted file types'\"\n    (onClick)=\"viewAcceptedFileTypes()\">\n  </yc-button>\n  <div>\n  <small>\n    <yc-i18n\n      key=\"common:maximumFileSizeText\"\n      [context]=\"{\n        maxFileSize: maxFileSizeForDisplay\n      }\"\n      defaultValue=\"Maximum file size: __maxFileSize__\">\n    </yc-i18n>\n  </small>\n</div>\n" }]
        }], ctorParameters: () => [{ type: FileService }, { type: i1.NotifierService }, { type: i3.I18nService }, { type: i4$1.LinkService }], propDecorators: { attachments: [{
                type: Input
            }], maxAttachments: [{
                type: Input
            }], maxAttachmentsTotalSize: [{
                type: Input
            }], onAddAttachment: [{
                type: Output
            }], onRemoveAttachment: [{
                type: Output
            }], downloadFile: [{
                type: Output
            }] } });

const maxFileSizeForEmailAttachments = 7000000; // Represents 7MB in bytes
const maxFileSizeDefault = 29000000; // Represents 29MB in bytes
const maxFileSizeForExternalEmailAttachments = 20000000; // Represents 20MB in bytes
const maxFileSizeDefaultInMb = 29;

class CanDownloadFilePipe {
    constructor(fileService) {
        this.fileService = fileService;
    }
    transform(file, allowDownload) {
        if (!allowDownload) {
            return false;
        }
        if (file?.fileUploadId) {
            return true;
        }
        else if (file?.fileUrl) {
            const info = this.fileService.breakdownUrl(file.fileUrl);
            const fileId = +(info?.fileId);
            return !!fileId;
        }
        return false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CanDownloadFilePipe, deps: [{ token: FileService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CanDownloadFilePipe, isStandalone: false, name: "ycCanDownloadFile" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CanDownloadFilePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycCanDownloadFile',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: FileService }] });

class MultiDropzoneInputComponent extends FormControlComponent {
    set value(value) {
        this._value = value;
        this.determineShouldPreventUpload();
    }
    get value() {
        return this._value;
    }
    constructor(i18n, formControlService, fileService, notifier, linkService, fileTypeService, arrayHelper, formGroup) {
        super(formGroup, formControlService);
        this.i18n = i18n;
        this.fileService = fileService;
        this.notifier = notifier;
        this.linkService = linkService;
        this.fileTypeService = fileTypeService;
        this.arrayHelper = arrayHelper;
        this.formGroup = formGroup;
        this.maxFileSize = maxFileSizeDefault;
        this.showRemoveFile = true;
        this.maxFiles = 1;
        this.useBlobInsteadOfFile = false;
        this.onFileDeleteClick = new EventEmitter();
        this.triggerUpload = new YCTwoWayEmitter();
        this.shouldPreventUpload = true;
        this.dropzoneHovered = false;
        this.dropzonePlaceholder = '';
        this.sub = new Subscription();
        this.acceptedFileTypesLink = this.linkService.getAcceptedFileTypesLink();
        this.hasError = false;
        this.isAfterInit = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.determineShouldPreventUpload();
        this.setMaxFileSizeForDisplay();
        this.setAcceptedFileTypesText();
        this.isAfterInit = true;
    }
    ngOnChanges(changes) {
        if (this.isAfterInit) {
            if (changes.maxFileSize) {
                this.setMaxFileSizeForDisplay();
            }
            if (changes.maxFiles) {
                this.determineShouldPreventUpload();
            }
            if (changes.acceptedFileTypes) {
                this.setAcceptedFileTypesText();
            }
        }
    }
    setAcceptedFileTypesText() {
        if (this.acceptedFileTypes?.length > 0) {
            const allAcceptedFileTypes = this.arrayHelper.sort(this.fileTypeService.getAllPermittedExtensions());
            const acceptedFileTypes = this.arrayHelper.sort(this.acceptedFileTypes);
            const isDifferentThanStandard = !isEqual(allAcceptedFileTypes, acceptedFileTypes);
            if (isDifferentThanStandard) {
                this.acceptedFileTypesText = this.i18n.translate('common:textAcceptedFileTypesInclude', {}, 'Accepted file types include') + ': ' + this.acceptedFileTypes.join(', ');
            }
            else {
                this.acceptedFileTypesText = '';
            }
        }
        else {
            this.acceptedFileTypesText = '';
        }
    }
    setMaxFileSizeForDisplay() {
        this.maxFileSizeForDisplay = this.fileService.maxFileSizeToUserFriendly(this.maxFileSize);
    }
    determineShouldPreventUpload(files) {
        if (this.maxFiles === 1) {
            this.shouldPreventUpload = false;
        }
        else {
            const filesAfterDrop = this.getTotalAfterDrop(files);
            this.shouldPreventUpload = (filesAfterDrop >= this.maxFiles);
        }
        this.setDropzonePlaceholder();
    }
    setDropzonePlaceholder() {
        if (this.shouldPreventUpload) {
            this.dropzonePlaceholder = this.i18n.translate('common:textMaximumFilesUploaded', {}, 'Maximum files uploaded');
        }
        else {
            this.dropzonePlaceholder = this.placeholder ||
                this.i18n.translate('common:textClickOrDropFilesHere', {}, 'Click or drop files here to upload');
        }
    }
    getTotalAfterDrop(files) {
        const numberOfFiles = (files?.length ?? 0);
        if (this.maxFiles === 1) {
            return numberOfFiles;
        }
        return (this.value?.length ?? 0) +
            numberOfFiles;
    }
    viewAcceptedFileTypes() {
        window.open(this.acceptedFileTypesLink, '_blank');
    }
    async onFileDownload(info) {
        this.fileDownloadFunc(info);
    }
    async manualUpload(e) {
        e.preventDefault();
        const target = e.target;
        await this.processFiles(target.files);
        target.value = '';
    }
    async handleFileDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dropzoneHovered = false;
        await this.processFiles(e.dataTransfer.files);
    }
    async processFiles(files) {
        this.determineShouldPreventUpload();
        if (this.shouldPreventUpload) {
            return;
        }
        const totalAfterDrop = this.getTotalAfterDrop(files);
        if (totalAfterDrop <= this.maxFiles) {
            let hasErrors = false;
            let newFiles = [];
            for (let index = 0; index < files.length; index++) {
                const file = files[index];
                const { hasError, ycFile } = await this.processFile(file);
                if (hasError) {
                    hasErrors = true;
                }
                else {
                    if (this.maxFiles === 1) {
                        newFiles = [
                            ycFile
                        ];
                    }
                    else {
                        newFiles = [
                            ycFile,
                            ...newFiles
                        ];
                    }
                }
            }
            this.hasError = hasErrors;
            if (newFiles.length > 0) {
                let files = [
                    ...newFiles,
                    ...this.value
                ];
                if (this.maxFiles === 1) {
                    files = [...newFiles];
                }
                super._onChange(files);
            }
        }
        else {
            this.notifier.error(this.i18n.translate(this.maxFiles === 1 ? 'common:textOnlyOneFileAllowed' : 'common:textMaxOfNumFilesAllowed', {
                number: this.maxFiles
            }, this.maxFiles === 1 ? 'Only one file allowed' : 'Max of __number__ files allowed'));
        }
        this.determineShouldPreventUpload();
    }
    async processFile(file) {
        let hasError = false;
        let ycFile;
        const fileValidationInfo = await this.fileService.validateFileUpload(file, this.maxFileSize, undefined, this.acceptedFileTypes);
        if (fileValidationInfo.validFile) {
            ycFile = new YcFile(file.name, file);
            if (!!this.uploadFunc) {
                ycFile = await this.uploadFunc(ycFile);
                if (!ycFile) {
                    hasError = true;
                }
            }
        }
        else {
            hasError = true;
            this.notifier.error(this.i18n.translate(fileValidationInfo.i18nKey, fileValidationInfo.i18nContext, fileValidationInfo.defaultText));
        }
        return {
            hasError,
            ycFile
        };
    }
    onDropzoneClick() {
        if (!this.shouldPreventUpload) {
            this.triggerUpload.emit();
        }
    }
    deleteFile(file, index) {
        const files = [
            ...this.value.slice(0, index),
            ...this.value.slice(index + 1)
        ];
        super._onChange(files);
        this.onFileDeleteClick.emit(file);
        this.determineShouldPreventUpload();
    }
    handleDragOver(e, isEnter) {
        e.preventDefault();
        e.stopPropagation();
        if (this.shouldPreventUpload) {
            return;
        }
        this.dropzoneHovered = isEnter;
    }
    _doOnChange(value, fromControlChange) {
        super._doOnChange(value, fromControlChange);
        this.determineShouldPreventUpload();
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MultiDropzoneInputComponent, deps: [{ token: i3.I18nService }, { token: i2.FormControlService }, { token: FileService }, { token: i1.NotifierService }, { token: i4$1.LinkService }, { token: FileTypeService }, { token: i4.ArrayHelpersService }, { token: i8.FormGroupDirective, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: MultiDropzoneInputComponent, isStandalone: false, selector: "yc-multi-dropzone-input", inputs: { maxFileSize: "maxFileSize", acceptedFileTypes: "acceptedFileTypes", showRemoveFile: "showRemoveFile", maxFiles: "maxFiles", uploadFunc: "uploadFunc", fileDownloadFunc: "fileDownloadFunc", useBlobInsteadOfFile: "useBlobInsteadOfFile", placeholder: "placeholder", value: "value" }, outputs: { onFileDeleteClick: "onFileDeleteClick" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\"\n  [class.disabled]=\"disabled\">\n\n  <!-- Label -->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [forFileUpload]=\"!disabled\"\n    [triggerUpload]=\"triggerUpload\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <ng-container *ngIf=\"!disabled\">\n    <input type=\"file\"\n      [name]=\"name\"\n      [id]=\"name\"\n      [tabIndex]=\"-1\"\n      aria-hidden=\"true\"\n      (change)=\"manualUpload($event)\">\n\n    <div class=\"form-input-wrapper\">\n      <!-- Dropzone -->\n      <div class=\"dropzone-input\"\n        [tabIndex]=\"tabIndex\"\n        [class.has-file-over]=\"dropzoneHovered\"\n        (dragover)=\"handleDragOver($event, true)\"\n        (dragleave)=\"handleDragOver($event, false)\"\n        (drop)=\"handleFileDrop($event)\"\n        (click)=\"onDropzoneClick()\"\n        (keyup.enter)=\"onDropzoneClick()\">\n        <yc-fa [light]=\"true\"\n          icon=\"cloud-upload fa-2x upload-icon\">\n        </yc-fa>\n        {{ dropzonePlaceholder }}\n        <small *ngIf=\"!shouldPreventUpload\">\n          <yc-i18n\n            key=\"common:maximumFileSizeText\"\n            [context]=\"{\n              maxFileSize: maxFileSizeForDisplay\n            }\"\n            defaultValue=\"Maximum file size: __maxFileSize__\">\n          </yc-i18n>\n        </small>\n      </div>\n    </div>\n\n    <yc-button *ngIf=\"hasError &&\n      acceptedFileTypesLink &&\n      (!acceptedFileTypes || acceptedFileTypes.length === 0)\"\n      class=\"mt-1\"\n      [link]=\"true\"\n      [langKey]=\"'common:textViewAcceptedFileTypes'\"\n      [defaultText]=\"'View accepted file types'\"\n      (onClick)=\"viewAcceptedFileTypes()\">\n    </yc-button>\n\n    <div *ngIf=\"acceptedFileTypes?.length > 0\">\n      {{ acceptedFileTypesText }}\n    </div>\n\n    <yc-form-help-or-error\n      [error]=\"error\"\n      [customError]=\"customError\"\n      [showError]=\"showError\"\n      [showHelp]=\"showHelp\"\n      [help]=\"help\"\n      [helpTextClass]=\"helpTextClass\">\n    </yc-form-help-or-error>\n  </ng-container>\n\n  <!-- List of Files Uploaded and Pending -->\n  <div class=\"uploaded-file-list\">\n    <div *ngFor=\"let file of value; let index = index;\"\n      class=\"uploaded-file\">\n      <!-- First Row -->\n      <div class=\"d-flex justify-content-between align-items-center\">\n        <div class=\"file-info\">\n          <yc-fa\n            [icon]=\"'file'\"\n            [light]=\"true\"\n            class=\"text-link me-2\">\n          </yc-fa>\n          <yc-button *ngIf=\"file | ycCanDownloadFile: !!fileDownloadFunc\"\n            [link]=\"true\"\n            [translatedText]=\"file.fileName\"\n            [value]=\"'common:textDownload' | ycI18n: 'Download'\"\n            [analyticsEventName]=\"'Download file'\"\n            (onClick)=\"onFileDownload({\n              file: file,\n              openFileInsteadOfDownload: true\n            })\">\n          </yc-button>\n          <span *ngIf=\"!(file | ycCanDownloadFile: !!fileDownloadFunc)\">\n            {{ file.fileName }}\n          </span>\n        </div>\n\n        <div class=\"file-actions\">\n          <!-- Download -->\n          <yc-button *ngIf=\"file | ycCanDownloadFile: !!fileDownloadFunc\"\n            [icon]=\"true\"\n            [fontAwesomeIcon]=\"'download'\"\n            [tooltipText]=\"'common:textDownload' | ycI18n: 'Download'\"\n            (onClick)=\"onFileDownload({\n              file: file,\n              openFileInsteadOfDownload: false\n            })\">\n          </yc-button>\n\n          <!-- Delete -->\n          <yc-button *ngIf=\"!disabled && showRemoveFile\"\n            [icon]=\"true\"\n            [fontAwesomeIcon]=\"'times'\"\n            [textDanger]=\"true\"\n            [tooltipText]=\"'common:btnDelete' | ycI18n: 'Delete'\"\n            (onClick)=\"deleteFile(file, index)\">\n          </yc-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: ["div.form-group.ng-invalid div.dropzone-input{border-color:#fd5739!important}.uploaded-file-list .uploaded-file{margin-top:.25rem;display:flex;justify-content:space-between;flex-direction:column}.dropzone-input{height:100%;width:100%;padding:1rem;border:1px dashed #6c757d;border-radius:.25rem;display:flex;flex-direction:column;align-items:center;justify-content:space-evenly;cursor:pointer}.dropzone-input.hover{border:1px solid #6c757d}.wrap-words{word-wrap:break-word}.pencil-link{padding-right:.37rem;padding-left:.37rem;padding-top:.12rem}.loading-dots:after{content:\" .\";animation:dots 1s steps(5,end) infinite}input[type=file]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.slim-dropzone{vertical-align:super;margin-left:1rem}@keyframes dots{0%,20%{color:#0000;text-shadow:.4rem 0 0 rgba(0,0,0,0),.8rem 0 0 rgba(0,0,0,0)}40%{color:#000;text-shadow:.4rem 0 0 rgba(0,0,0,0),.8rem 0 0 rgba(0,0,0,0)}60%{text-shadow:.4rem 0 0 black,.8rem 0 0 rgba(0,0,0,0)}80%,to{text-shadow:.4rem 0 0 black,.8rem 0 0 black}}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.ButtonComponent, selector: "yc-button", inputs: ["tabIndex", "disabled", "size", "fontSize", "buttonType", "primary", "link", "linkPath", "icon", "secondary", "textDanger", "textWarning", "textPrimary", "textSuccess", "borderOnHover", "noClick", "badgeValue", "value", "ariaDescribedBy", "minWidth", "alignTop", "tooltipText", "popoverTemplate", "container", "popoverContext", "popoverIsOpen", "popoverOutsideClickToClose", "placement", "adaptivePosition", "langKey", "defaultText", "translatedText", "fontAwesomeIcon", "isDropdownButton", "isFooterButton", "dropdownDirection", "dropdownActions", "isDropdownToggle", "isSplitDropdownToggle", "preventClickTracking", "leftAlignLinkText", "analyticsEventName", "customColor", "buttonElementId", "includeExpandedAria", "ariaExpanded"], outputs: ["onClick", "popoverIsOpenChange", "onPopoverReady", "onPopoverClick"] }, { kind: "component", type: i7.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }, { kind: "component", type: i3.I18nComponent, selector: "yc-i18n", inputs: ["key", "defaultValue", "context", "transform"] }, { kind: "component", type: i2.FormLabelComponent, selector: "yc-form-label", inputs: ["name", "label", "srOnly", "description", "tabIndex", "cursorStyle", "tooltipText", "popoverTemplate", "showQuestionMarkForTooltip", "asteriskForRequired", "forRadioButtons", "customIcon", "customIconTooltip", "customIconClass", "forFileUpload", "triggerUpload"] }, { kind: "component", type: i2.FormHelpOrErrorComponent, selector: "yc-form-help-or-error", inputs: ["error", "customError", "showError", "showHelp", "help", "helpTextClass"] }, { kind: "pipe", type: i3.I18nPipe, name: "ycI18n" }, { kind: "pipe", type: CanDownloadFilePipe, name: "ycCanDownloadFile" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MultiDropzoneInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-multi-dropzone-input', standalone: false, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\"\n  [class.disabled]=\"disabled\">\n\n  <!-- Label -->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [forFileUpload]=\"!disabled\"\n    [triggerUpload]=\"triggerUpload\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <ng-container *ngIf=\"!disabled\">\n    <input type=\"file\"\n      [name]=\"name\"\n      [id]=\"name\"\n      [tabIndex]=\"-1\"\n      aria-hidden=\"true\"\n      (change)=\"manualUpload($event)\">\n\n    <div class=\"form-input-wrapper\">\n      <!-- Dropzone -->\n      <div class=\"dropzone-input\"\n        [tabIndex]=\"tabIndex\"\n        [class.has-file-over]=\"dropzoneHovered\"\n        (dragover)=\"handleDragOver($event, true)\"\n        (dragleave)=\"handleDragOver($event, false)\"\n        (drop)=\"handleFileDrop($event)\"\n        (click)=\"onDropzoneClick()\"\n        (keyup.enter)=\"onDropzoneClick()\">\n        <yc-fa [light]=\"true\"\n          icon=\"cloud-upload fa-2x upload-icon\">\n        </yc-fa>\n        {{ dropzonePlaceholder }}\n        <small *ngIf=\"!shouldPreventUpload\">\n          <yc-i18n\n            key=\"common:maximumFileSizeText\"\n            [context]=\"{\n              maxFileSize: maxFileSizeForDisplay\n            }\"\n            defaultValue=\"Maximum file size: __maxFileSize__\">\n          </yc-i18n>\n        </small>\n      </div>\n    </div>\n\n    <yc-button *ngIf=\"hasError &&\n      acceptedFileTypesLink &&\n      (!acceptedFileTypes || acceptedFileTypes.length === 0)\"\n      class=\"mt-1\"\n      [link]=\"true\"\n      [langKey]=\"'common:textViewAcceptedFileTypes'\"\n      [defaultText]=\"'View accepted file types'\"\n      (onClick)=\"viewAcceptedFileTypes()\">\n    </yc-button>\n\n    <div *ngIf=\"acceptedFileTypes?.length > 0\">\n      {{ acceptedFileTypesText }}\n    </div>\n\n    <yc-form-help-or-error\n      [error]=\"error\"\n      [customError]=\"customError\"\n      [showError]=\"showError\"\n      [showHelp]=\"showHelp\"\n      [help]=\"help\"\n      [helpTextClass]=\"helpTextClass\">\n    </yc-form-help-or-error>\n  </ng-container>\n\n  <!-- List of Files Uploaded and Pending -->\n  <div class=\"uploaded-file-list\">\n    <div *ngFor=\"let file of value; let index = index;\"\n      class=\"uploaded-file\">\n      <!-- First Row -->\n      <div class=\"d-flex justify-content-between align-items-center\">\n        <div class=\"file-info\">\n          <yc-fa\n            [icon]=\"'file'\"\n            [light]=\"true\"\n            class=\"text-link me-2\">\n          </yc-fa>\n          <yc-button *ngIf=\"file | ycCanDownloadFile: !!fileDownloadFunc\"\n            [link]=\"true\"\n            [translatedText]=\"file.fileName\"\n            [value]=\"'common:textDownload' | ycI18n: 'Download'\"\n            [analyticsEventName]=\"'Download file'\"\n            (onClick)=\"onFileDownload({\n              file: file,\n              openFileInsteadOfDownload: true\n            })\">\n          </yc-button>\n          <span *ngIf=\"!(file | ycCanDownloadFile: !!fileDownloadFunc)\">\n            {{ file.fileName }}\n          </span>\n        </div>\n\n        <div class=\"file-actions\">\n          <!-- Download -->\n          <yc-button *ngIf=\"file | ycCanDownloadFile: !!fileDownloadFunc\"\n            [icon]=\"true\"\n            [fontAwesomeIcon]=\"'download'\"\n            [tooltipText]=\"'common:textDownload' | ycI18n: 'Download'\"\n            (onClick)=\"onFileDownload({\n              file: file,\n              openFileInsteadOfDownload: false\n            })\">\n          </yc-button>\n\n          <!-- Delete -->\n          <yc-button *ngIf=\"!disabled && showRemoveFile\"\n            [icon]=\"true\"\n            [fontAwesomeIcon]=\"'times'\"\n            [textDanger]=\"true\"\n            [tooltipText]=\"'common:btnDelete' | ycI18n: 'Delete'\"\n            (onClick)=\"deleteFile(file, index)\">\n          </yc-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: ["div.form-group.ng-invalid div.dropzone-input{border-color:#fd5739!important}.uploaded-file-list .uploaded-file{margin-top:.25rem;display:flex;justify-content:space-between;flex-direction:column}.dropzone-input{height:100%;width:100%;padding:1rem;border:1px dashed #6c757d;border-radius:.25rem;display:flex;flex-direction:column;align-items:center;justify-content:space-evenly;cursor:pointer}.dropzone-input.hover{border:1px solid #6c757d}.wrap-words{word-wrap:break-word}.pencil-link{padding-right:.37rem;padding-left:.37rem;padding-top:.12rem}.loading-dots:after{content:\" .\";animation:dots 1s steps(5,end) infinite}input[type=file]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.slim-dropzone{vertical-align:super;margin-left:1rem}@keyframes dots{0%,20%{color:#0000;text-shadow:.4rem 0 0 rgba(0,0,0,0),.8rem 0 0 rgba(0,0,0,0)}40%{color:#000;text-shadow:.4rem 0 0 rgba(0,0,0,0),.8rem 0 0 rgba(0,0,0,0)}60%{text-shadow:.4rem 0 0 black,.8rem 0 0 rgba(0,0,0,0)}80%,to{text-shadow:.4rem 0 0 black,.8rem 0 0 black}}\n"] }]
        }], ctorParameters: () => [{ type: i3.I18nService }, { type: i2.FormControlService }, { type: FileService }, { type: i1.NotifierService }, { type: i4$1.LinkService }, { type: FileTypeService }, { type: i4.ArrayHelpersService }, { type: i8.FormGroupDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { maxFileSize: [{
                type: Input
            }], acceptedFileTypes: [{
                type: Input
            }], showRemoveFile: [{
                type: Input
            }], maxFiles: [{
                type: Input
            }], uploadFunc: [{
                type: Input
            }], fileDownloadFunc: [{
                type: Input
            }], useBlobInsteadOfFile: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], onFileDeleteClick: [{
                type: Output
            }] } });

class GetFileNameFromUrlPipe {
    constructor(fileService) {
        this.fileService = fileService;
    }
    transform(url) {
        if (url) {
            const info = this.fileService.breakdownUrl(url);
            return info?.fileName ?? url;
        }
        return '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: GetFileNameFromUrlPipe, deps: [{ token: FileService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: GetFileNameFromUrlPipe, isStandalone: false, name: "ycGetFileNameFromUrl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: GetFileNameFromUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycGetFileNameFromUrl',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: FileService }] });

class FilesModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FilesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: FilesModule, declarations: [MultiDropzoneInputComponent,
            CanDownloadFilePipe,
            GetFileNameFromUrlPipe,
            AddAttachmentButtonComponent], imports: [CommonModule,
            LinksModule,
            ButtonModule,
            IconsModule,
            I18nModule,
            UtilsModule,
            CoreFormsModule], exports: [MultiDropzoneInputComponent,
            CanDownloadFilePipe,
            GetFileNameFromUrlPipe,
            AddAttachmentButtonComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FilesModule, imports: [CommonModule,
            LinksModule,
            ButtonModule,
            IconsModule,
            I18nModule,
            UtilsModule,
            CoreFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FilesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LinksModule,
                        ButtonModule,
                        IconsModule,
                        I18nModule,
                        UtilsModule,
                        CoreFormsModule
                    ],
                    declarations: [
                        MultiDropzoneInputComponent,
                        CanDownloadFilePipe,
                        GetFileNameFromUrlPipe,
                        AddAttachmentButtonComponent
                    ],
                    exports: [
                        MultiDropzoneInputComponent,
                        CanDownloadFilePipe,
                        GetFileNameFromUrlPipe,
                        AddAttachmentButtonComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AddAttachmentButtonComponent, CanDownloadFilePipe, FileService, FileTypeService, FilesModule, GetFileNameFromUrlPipe, MultiDropzoneInputComponent, TableDataDownloadFormat, YcFile, b64Regex, maskedFileName, maxFileSizeDefault, maxFileSizeDefaultInMb, maxFileSizeForEmailAttachments, maxFileSizeForExternalEmailAttachments };
